import { render, staticRenderFns } from "./EditLinkPopup.vue?vue&type=template&id=bb6d4384&scoped=true&"
import script from "./EditLinkPopup.vue?vue&type=script&lang=js&"
export * from "./EditLinkPopup.vue?vue&type=script&lang=js&"
import style0 from "./EditLinkPopup.vue?vue&type=style&index=0&id=bb6d4384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6d4384",
  null
  
)

export default component.exports